import { tViews } from '../../../../../utils/table';

export default {
  get title() { return tViews('circuitTableAvailability'); },
  get subTitle() { return tViews('circuitViewCircuits'); },
  legend: {
    theme: "overlay",
    labels: [
      tViews('applicationCircuitViewLabelAvailable'),
      tViews('applicationCircuitViewLabelPrevious'),
      tViews('applicationOverviewTotal')
    ]
  },
  columns: [
    {
      get title() { return tViews('circuitViewCircuits'); },
      colSpan: 1,
      property: "circuit_display_name",
      type: "string",
      format: "link",
      maxLength: 22,
    },
    {
      get title() { return tViews('dashletSiteViewAvailabilityPerValue'); },
      colSpan: 1,
      property: "availability",
      type: "number",
      format: "percent",
      theme: "changeQuality",
      tooltip: true,
      get tooltipTitle() { return String(tViews('circuitAvailBarChart') || ''); },
      get tooltipDefinition() { return String(tViews('circuitAvailBarChartDefinition') || ''); },
      padding: "5px"
    },
    {
      get title() { return tViews('circuitViewTotalTime'); },
      colSpan: 1,
      property: "chart",
      type: "chart",
      format: "overlayBarChart",
      padding: "0px 0px 0px 4px"
    }
  ]
};
